module.exports = __webpack_public_path__ + "static/img/I1.39cf5a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/I1.png
// module id = wWJC
// module chunks = 0